export enum AvailableAuthMethods {
    PASSWORD = 'AUTHENTICATION_METHOD_TYPE_PASSWORD',
    TOTP = 'AUTHENTICATION_METHOD_TYPE_TOTP',
    OTP_EMAIL = 'AUTHENTICATION_METHOD_TYPE_OTP_EMAIL',
    OTP_SMS = 'AUTHENTICATION_METHOD_TYPE_OTP_SMS',
}

export const MFAMethods = [AvailableAuthMethods.TOTP, AvailableAuthMethods.OTP_EMAIL, AvailableAuthMethods.OTP_SMS];